
import React, { useState } from 'react';
import {
  AuthContainer,
  AuthCard,
  AuthHeader,
  AuthSubtitle,
  AuthForm,
  FormField,
  FormLabel,
  FormInput,
  PasswordInput,
  PasswordInputField,
  TogglePasswordButton,
  FormGrid,
  FormActions,
  AuthButton,
  AuthFooter,
  AuthAlt,
  AuthLink
} from '../../styles/AuthStyles';
import { SignUpApi } from '../../common/CommonApi';
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom';

const UserRegister = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async(event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      return;
    }
    let resp = await SignUpApi({ fullName, email, password  });
    if(resp && resp.status === 200){
      Swal.fire({
        position: "top-end",
        text: "User registered successfully",
        icon: "success"
      });
      navigate('/login');
    }
  };

  return (
    <AuthContainer>
      <AuthCard>
        <AuthHeader>
          <img src='./assets/logo.png' alt="Logo" style={{width:"150px"}}/>
          <AuthSubtitle>Join the admin portal</AuthSubtitle>
        </AuthHeader>

        <AuthForm onSubmit={handleSubmit}>
          <FormField>
            <FormLabel htmlFor="fullName">Full name</FormLabel>
            <FormInput
              id="fullName"
              type="text"
              placeholder="Jane Doe"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              autoComplete="name"
            />
          </FormField>

          <FormField>
            <FormLabel htmlFor="email">Email</FormLabel>
            <FormInput
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </FormField>

          <FormGrid>
            <FormField>
              <FormLabel htmlFor="password">Password</FormLabel>
              <PasswordInput>
                <PasswordInputField
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Create a password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
                <TogglePasswordButton
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </TogglePasswordButton>
              </PasswordInput>
            </FormField>

            <FormField>
              <FormLabel htmlFor="confirmPassword">Confirm password</FormLabel>
              <PasswordInput>
                <PasswordInputField
                  id="confirmPassword"
                  type={showConfirmPassword ? 'text' : 'password'}
                  placeholder="Re-enter password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
                <TogglePasswordButton
                  type="button"
                  onClick={() => setShowConfirmPassword((v) => !v)}
                  aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
                >
                  {showConfirmPassword ? 'Hide' : 'Show'}
                </TogglePasswordButton>
              </PasswordInput>
            </FormField>
          </FormGrid>

          <FormActions>
            <AuthButton type="submit">Create account</AuthButton>
          </FormActions>
        </AuthForm>

        <AuthFooter>
          <AuthAlt>
            Already have an account? <AuthLink href="/login">Sign in</AuthLink>
          </AuthAlt>
        </AuthFooter>
      </AuthCard>
    </AuthContainer>
  );
};

export default UserRegister;